export const rp = (n) => "Rp " + Math.round(Number(n) || 0).toLocaleString("id-ID");
export const num = (n) => Math.round(Number(n) || 0).toLocaleString("id-ID");
export const parseNum = (s) => Number(String(s).replace(/[^\d]/g, "")) || 0;

export const TZ = "Asia/Jakarta";
export const fmtDate = (iso) =>
  new Date(iso).toLocaleString("id-ID", { timeZone: TZ, day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) + " WIB";
export const fmtFull = (iso) => new Date(iso).toLocaleString("id-ID", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) + " WIB";
export const fmtTime = (d) => new Date(d).toLocaleTimeString("id-ID", { timeZone: TZ }) + " WIB";
export const todayWIB = () => new Date(Date.now() + 7 * 3600000).toISOString().slice(0, 10);

export const METHODS = {
  tunai: "Tunai",
  debit: "Kartu Debit",
  kredit: "Kartu Kredit",
  qris: "QRIS",
  transfer: "Transfer Bank",
  ewallet: "E-Wallet",
};

const H7 = 7 * 3600000;
const wibParts = (ms) => {
  const d = new Date(ms + H7);
  return [d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()];
};
const startOfDay = (y, m, d) => new Date(Date.UTC(y, m, d) - H7);
const endOfDay = (y, m, d) => new Date(Date.UTC(y, m, d + 1) - H7 - 1);

export function rangeFor(preset, from, to) {
  const [y, m, d] = wibParts(Date.now());
  let s = startOfDay(y, m, d);
  let e = endOfDay(y, m, d);
  if (preset === "yesterday") {
    s = startOfDay(y, m, d - 1);
    e = endOfDay(y, m, d - 1);
  } else if (preset === "7d") s = startOfDay(y, m, d - 6);
  else if (preset === "30d") s = startOfDay(y, m, d - 29);
  else if (preset === "month") s = startOfDay(y, m, 1);
  else if (preset === "custom" && from && to) {
    const [fy, fm, fd] = from.split("-").map(Number);
    const [ty, tm, td] = to.split("-").map(Number);
    s = startOfDay(fy, fm - 1, fd);
    e = endOfDay(ty, tm - 1, td);
  }
  return { start: s.toISOString(), end: e.toISOString() };
}

export const tzOffset = () => 420;

export const PRESETS = [
  ["today", "Hari Ini"],
  ["yesterday", "Kemarin"],
  ["7d", "7 Hari"],
  ["30d", "30 Hari"],
  ["month", "Bulan Ini"],
  ["custom", "Pilih Tanggal"],
];

export function downloadCSV(filename, rows) {
  const csv = rows.map((r) => r.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
}

export function beep() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = 1800;
    g.gain.value = 0.08;
    o.connect(g);
    g.connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + 0.08);
  } catch (e) {
    /* audio not available */
  }
}
